@let isLoading = loading;
@let passwordManagerPlans = this.passwordManagerPlans;
@let secretsManagerPlans = this.secretsManagerPlans;
@let upgradingFromPremium = this.canUpgradeFromPremium();

@if (isLoading) {
  <ng-container>
    <bit-icon
      name="bwi-spinner"
      class="bwi-spin tw-text-muted"
      title="{{ 'loading' | i18n }}"
      aria-hidden="true"
    ></bit-icon>
    <span class="tw-sr-only">{{ "loading" | i18n }}</span>
  </ng-container>
}
@if (createOrganization() && selfHosted) {
  <ng-container>
    <organization-self-hosting-license-uploader
      (onLicenseFileUploaded)="onLicenseFileUploaded($event)"
    />
  </ng-container>
}
@if (!isLoading && !selfHosted && passwordManagerPlans && secretsManagerPlans) {
  <form [formGroup]="formGroup" [bitSubmit]="submit" class="tw-pt-6">
    <bit-section [ngClass]="{ 'tw-hidden': !createOrganization() }">
      <app-org-info
        (changedBusinessOwned)="changedOwnedBusiness()"
        [formGroup]="formGroup"
        [createOrganization]="createOrganization()"
        [isProvider]="!!providerId()"
        [acceptingSponsorship]="acceptingSponsorship()"
      >
      </app-org-info>

      <div class="tw-p-4 tw-rounded-lg tw-bg-background-alt tw-border tw-border-border-subtle tw-mt-4 tw-mb-4">
        <div class="tw-flex tw-items-center tw-gap-3">
          <i class="bwi bwi-admin-console tw-text-2xl tw-text-primary" aria-hidden="true"></i>
          <div>
            <h3 class="tw-font-semibold tw-text-base tw-mb-1">Plano Empresarial Prolinkdigital</h3>
            <p class="tw-text-sm tw-text-muted tw-mb-0">
              Todas as funcionalidades empresariais inclusas: membros ilimitados, partilha de cofres e coleções, políticas de segurança, grupos de acesso e registos de auditoria.
            </p>
          </div>
        </div>
      </div>
    </bit-section>

    @if (!createOrganization()) {
      <bit-section>
        <h2 bitTypography="h2">{{ "chooseYourPlan" | i18n }}</h2>
        <bit-radio-group formControlName="productTier" [block]="true">
          @for (selectableProduct of selectableProducts(); track $index) {
            @let pm = selectableProduct.PasswordManager;
            @let tier = selectableProduct.productTier;
            <div class="tw-mb-3">
              <bit-radio-button [value]="tier" (change)="changedProduct()">
                <bit-label>{{ selectableProduct.nameLocalizationKey | i18n }}</bit-label>
              </bit-radio-button>
            </div>
          }
        </bit-radio-group>
      </bit-section>
    }

    @if (singleOrgPolicyBlock) {
      <bit-section>
        <bit-callout type="danger" [title]="'error' | i18n">
          {{ "singleOrgBlockCreateMessage" | i18n }}
        </bit-callout>
      </bit-section>
    }
    <bit-section>
      <button
        type="submit"
        buttonType="primary"
        bitButton
        bitFormButton
        [disabled]="!formGroup.valid"
      >
        {{ "submit" | i18n }}
      </button>
      @if (showCancel()) {
        <button type="button" buttonType="secondary" bitButton bitFormButton (click)="cancel()">
          {{ "cancel" | i18n }}
        </button>
      }
      <bit-error-summary [formGroup]="formGroup"></bit-error-summary>
    </bit-section>
  </form>
}
